import React from 'react'
import styled from 'styled-components'

function ProjectHeader(props) {
    var pg = props.pg
    var viewTitle = props.viewTitle

    if (!pg) {
        return null
    }

    var isAdminPage = window.location.pathname.indexOf('/Admin') !== -1

    var processSteps = [
        '임시저장',
        '프로젝트 등록',
        '견적서 작성',
        '견적서 수신',
        '견적서 승인',
        '계약서 작성',
        '계약서 수신',
        '계약서 서명',
        '선금 납부',
        '1단계 개발',
        '1단계 보고서 수신',
        '1단계 보고서 승인',
        '중도금 납부',
        '2단계 개발',
        '2단계 보고서 수신',
        '2단계 보고서 승인',
        '3단계 개발',
        '3단계 보고서 수신',
        '3단계 보고서 승인',
        '잔금 납부',
        '프로젝트 완료',
    ]

    return (
        <HeaderWrap>
            {isAdminPage ? (
                <ProcessRow>
                    <ProcessLabel>프로젝트 진행 과정:</ProcessLabel>

                    {processSteps.map(function (step, index) {
                        var active = pg.adminstatus === step

                        return (
                            <React.Fragment key={step}>
                                <ProcessBox active={active}>{step}</ProcessBox>
                                {index < processSteps.length - 1 ? <ArrowText>→</ArrowText> : ''}
                            </React.Fragment>
                        )
                    })}
                </ProcessRow>
            ) : (
                ''
            )}

            <TopRow>
                <TitleWrap>
                    <TitleBadge>{viewTitle}</TitleBadge>
                    <Title>{pg.title}</Title>
                </TitleWrap>

                <DateWrap>
                    <DateText>등록일 : {pg.createdtime}</DateText>
                    <DateText>수정일 : {pg.updatetime}</DateText>
                </DateWrap>
            </TopRow>

            <SubCateRow>
                <MainCate>{pg.cateother ? pg.cateother : pg.cate}</MainCate>

                <CrossLine />

                <SubCateList>
                    {pg.minicateother ? (
                        <>
                            {pg.minicate &&
                                pg.minicate.map(function (value) {
                                    return <SubCateItem key={value}>{value}</SubCateItem>
                                })}
                            <SubCateItem>{pg.minicateother}</SubCateItem>
                        </>
                    ) : (
                        <>
                            {pg.minicate &&
                                pg.minicate.map(function (value) {
                                    return <SubCateItem key={value}>{value}</SubCateItem>
                                })}
                        </>
                    )}
                </SubCateList>
            </SubCateRow>
        </HeaderWrap>
    )
}

export default ProjectHeader

const HeaderWrap = styled.div`
    width: 100%;
`
const ProcessLabel = styled.span`
    flex-shrink: 0;
    margin-right: 6px;
    font-size: 13px;
    font-weight: bold;
    color: #222;
`
const ProcessRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    overflow-x: auto;
    white-space: nowrap;
`

const ProcessBox = styled.div`
    flex-shrink: 0;
    padding: 5px 8px;
    font-size: 11px;
    font-weight: 700;
    border: 1px solid ${(props) => (props.active ? '#11296b' : '#cfcfcf')};
    background-color: ${(props) => (props.active ? '#11296b' : '#fff')};
    color: ${(props) => (props.active ? '#fff' : '#333')};
    border-radius: 3px;
`

const ArrowText = styled.span`
    flex-shrink: 0;
    font-size: 12px;
    color: #999;
`

const TopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
`

const TitleWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    min-width: 0;
`

const TitleBadge = styled.span`
    margin-top: 10px;
    padding: 5px 10px;
    margin-right: 10px;
    font-size: 16px;
    font-weight: bold;
    background-color: #11296b;
    color: #fff;
    border-radius: 5px;
    text-align: center;
    /* line-height: 1.2; */
    flex-shrink: 0;
    transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;
    &:hover {
        background-color: #798377 !important;
    }
`

const Title = styled.h1`
    margin: 0;
    margin-top: 10px;
    padding: 5px 0;
    font-size: 24px;
    font-weight: 900;
    color: #111;
    /* line-height: 1.35; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

const DateWrap = styled.div`
    width: 50%;
    flex-shrink: 0;
    text-align: right;
`

const DateText = styled.div`
    font-size: 14px;
    color: #757575;
    line-height: 1.7;
`

const SubCateRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #757575;
`

const MainCate = styled.span`
    position: relative;
    width: 80px;
    height: 25px;
    margin-right: 10px;
    padding: 8px 12px;
    font-size: 10.2px;
    font-weight: 700;
    border: 1px solid #3e424734;
    border-radius: 5px;
    color: #000;
    text-align: center;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
`

const CrossLine = styled.div`
    width: 1px;
    height: 16px;
    background-color: #757575;
`

const SubCateList = styled.ul`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0;
    margin: 0 0 0 12px;
    padding: 0;
    list-style: none;
`

const SubCateItem = styled.li`
    position: relative;
    width: 75px;
    height: 25px;
    margin-right: 0;
    font-size: 10.2px;
    font-weight: 700;
    border: 1px solid #3e424734;
    border-radius: 5px;
    color: #000;
    text-align: center;
    background-color: #fff;
    padding: 8px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
`
